import { render, staticRenderFns } from "./mediaWhiteList.vue?vue&type=template&id=af61c262&scoped=true"
import script from "./mediaWhiteList.vue?vue&type=script&lang=js"
export * from "./mediaWhiteList.vue?vue&type=script&lang=js"
import style0 from "./mediaWhiteList.vue?vue&type=style&index=0&id=af61c262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af61c262",
  null
  
)

export default component.exports